var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 7.17424 7.1635 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0108",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73959 8.35864C9.73959 6.02751 11.3779 4.08014 13.5656 3.60232C13.2294 3.52895 12.8806 3.48914 12.5221 3.48914C9.83271 3.48914 7.65259 5.66926 7.65259 8.3587C7.65259 11.0481 9.83271 13.2283 12.5221 13.2283C12.8805 13.2283 13.2293 13.1884 13.5656 13.115C11.3779 12.6372 9.73959 10.6898 9.73959 8.35864V8.35864Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 3.83701L16.3456 4.89982H17.4632L16.559 5.55676L16.9044 6.61957L16.0002 5.96276L15.0961 6.61957L15.4415 5.55676L14.5374 4.89982H15.6549L16.0002 3.83701Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2894 5.92383L13.6347 6.9867H14.7523L13.8482 7.64358L14.1935 8.70639L13.2894 8.04958L12.3852 8.70639L12.7306 7.64358L11.8264 6.9867H12.944L13.2894 5.92383Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7124 5.92383L19.0578 6.9867H20.1753L19.2711 7.64358L19.6166 8.70639L18.7124 8.04958L17.8083 8.70639L18.1536 7.64358L17.2495 6.9867H18.367L18.7124 5.92383Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 9.05435L18.0126 10.1172H19.1301L18.226 10.7741L18.5713 11.8369L17.6672 11.1801L16.7631 11.8369L17.1085 10.7741L16.2043 10.1172H17.3218L17.6672 9.05435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 9.05435L14.6786 10.1172H15.7962L14.892 10.7741L15.2375 11.8369L14.3333 11.1801L13.4291 11.8369L13.7745 10.7741L12.8704 10.1172H13.9879L14.3333 9.05435Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.9dd771ba.svg";
export { ForwardRef as ReactComponent };